module.exports = __webpack_public_path__ + "static/images/6bdac767.png";